module.exports = __webpack_public_path__ + "img/achievement_13.dc01eb3a.png";